import cloneDeep from 'lodash/cloneDeep';

export function removeKeysFromObject<T extends Record<string, any>>(obj: T, keysToRemove: string[]): T {
  const newObj: any = cloneDeep(obj);

  function recurse(currentObj: Record<string, any>): void {
    if (Array.isArray(currentObj)) {
      currentObj.forEach((item) => recurse(item));

    } else if (typeof currentObj === 'object' && currentObj !== null) {

      Object.entries(currentObj).forEach(([key, value]) => {
        if (keysToRemove.includes(key)) {
          //@ts-ignore
          delete currentObj[key];
        } else if (typeof value === 'object' && value !== null) {

          recurse(value);
        }
      });
    }
  }

  // Comienza la recursión en el objeto clonado
  recurse(newObj);
  return newObj;
}


export const arrayToObjectIndexed = (array: any[], fieldIndexed: string) => {
  return array.reduce((acc, obj) => {
    acc[obj[fieldIndexed]] = obj;
    return acc;
  }, {});
};

